import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/constants/site";
import BookingDialog from "@/components/BookingDialog";

export default function FAQs() {
  return (
    <div data-testid="faqs-page">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="eyebrow text-[#1E3A8A]">Help center</div>
        <h1 className="font-display heading-uppercase text-5xl sm:text-6xl leading-[0.95] mt-3">
          Frequently asked <span className="text-[#1E3A8A]">questions.</span>
        </h1>
        <p className="mt-6 text-slate-700 text-lg leading-relaxed">Everything parents need to know before booking. Can't find what you're looking for? Get in touch.</p>

        <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-50 divide-y divide-slate-200">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`q-${i}`} className="px-6 border-slate-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display uppercase text-lg text-left hover:text-[#1E3A8A] [&[data-state=open]]:text-[#1E3A8A]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-700 text-sm leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-12 rounded-3xl border border-[#1E3A8A]/30 bg-slate-50 p-10 text-center">
          <h3 className="font-display uppercase text-3xl">Still have questions?</h3>
          <p className="text-slate-500 mt-2">Reach out — we typically reply within a few hours.</p>
          <div className="mt-6 flex justify-center gap-3 flex-wrap">
            <BookingDialog trigger={<button data-testid="faqs-book-btn" className="btn-gold">Book a Session</button>} />
            <a href="/contact" className="btn-outline-blue" data-testid="faqs-contact-btn">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}
